export default function SiteFooter() {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-slate-500">
          © {new Date().getFullYear()} AI Operator Hub. All recommendations are independent.
        </p>
        <p className="text-xs text-slate-400">
          Links open the official website. We do not earn affiliate commission yet.
        </p>
      </div>
    </footer>
  );
}
